module.exports = __webpack_public_path__ + "img/spinner.5073b65e.gif";